var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { fileExtension2VideoType } from '../base/play-helper';
import { SET_LEVEL_MODE, VIDEO_TYPE } from '../enums';
import { commonTool, logMethodCallDecoratorCreator, uaTool, urlTool } from '../util';
import OrgVideoNode from './org-videonode';
var logMethodCall = logMethodCallDecoratorCreator('OrgIOSVideoNode');
// 暂停的阈值时长
var PAUSE_TIME_THRESHOLD = 5 * 1000;
/**
 * iOS 原生播放专用 VideoNode，用于兼容 iOS 播放中的 bug
 */
var OrgIOSVideoNode = /** @class */ (function (_super) {
    __extends(OrgIOSVideoNode, _super);
    function OrgIOSVideoNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 上次调用 pause 时的播放时间 */
        _this.lastPausePlayTime = null;
        /** 上次调用 pause 时的时间戳 */
        _this.lastPauseTimeStamp = null;
        /** 是否屏蔽 seek 事件 */
        _this.disableSeekEvt = false;
        return _this;
    }
    Object.defineProperty(OrgIOSVideoNode, "shouldUseResumeFix", {
        /**
         * 是否启用 Bug 兼容处理：https://git.woa.com/ThumbPlayerMaster/ThumbPlayerH5/thumbplayer-h5/issues/98
         * iOS 15 ，如果 < iOS 15.0 则不做处理
         */
        get: function () {
            return uaTool.os.ios
                && commonTool.compareVersion(uaTool.os.version, '15.0') >= 0;
        },
        enumerable: false,
        configurable: true
    });
    OrgIOSVideoNode.prototype.setLevel = function (mode) {
        if (mode === void 0) { mode = SET_LEVEL_MODE.HARD; }
        this.clearPauseMemTime();
        return _super.prototype.setLevel.call(this, mode);
    };
    OrgIOSVideoNode.prototype.onVideoEventPause = function () {
        /**
         * Webkit Bug:
         * 这里 iOS 15 存在一个 Bug，当暂停播放后，将浏览器切换到后台约 10s，再切回来播放
         * 则起播时间和上次暂停的不一致，起播时间可能会增加 0.5 ~ 3分钟
         * @see https://git.woa.com/ThumbPlayerMaster/ThumbPlayerH5/thumbplayer-h5/issues/98
         */
        if (this.isOriginHlsPlaying()) {
            this.lastPausePlayTime = this._video.currentTime;
            this.lastPauseTimeStamp = Date.now();
        }
        return _super.prototype.onVideoEventPause.call(this);
    };
    OrgIOSVideoNode.prototype.onVideoEventSeeking = function () {
        this.clearPauseMemTime();
        if (this.disableSeekEvt) {
            return;
        }
        return _super.prototype.onVideoEventSeeking.call(this);
    };
    OrgIOSVideoNode.prototype.onVideoEventSeeked = function () {
        if (this.disableSeekEvt) {
            this.disableSeekEvt = false;
            return;
        }
        _super.prototype.onVideoEventSeeked.call(this);
    };
    OrgIOSVideoNode.prototype.onVideoEventPlaying = function () {
        // 如果是特定版本的 iOS 设备，在起播时，如果 pause 的时间超过阈值，则强行 seek 回来
        if (OrgIOSVideoNode.shouldUseResumeFix
            && this.lastPausePlayTime
            && Date.now() - this.lastPauseTimeStamp > PAUSE_TIME_THRESHOLD) {
            this.disableSeekEvt = true;
            this._video.currentTime = this.lastPausePlayTime;
        }
        this.clearPauseMemTime();
        return _super.prototype.onVideoEventPlaying.call(this);
    };
    OrgIOSVideoNode.prototype.clearPauseMemTime = function () {
        this.lastPausePlayTime = null;
        this.lastPauseTimeStamp = null;
    };
    /**
     * 从 loadingURL 判断是否在原生播放 HLS
     * @return 是否为 hls
     */
    OrgIOSVideoNode.prototype.isOriginHlsPlaying = function () {
        var loadingUrl = this.currentVideoInfo.loadingUrl;
        var ext = urlTool.getFileExtension(loadingUrl);
        return fileExtension2VideoType(ext) === VIDEO_TYPE.HLS;
    };
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], OrgIOSVideoNode.prototype, "setLevel", null);
    return OrgIOSVideoNode;
}(OrgVideoNode));
export { OrgIOSVideoNode };
